<template>
  <div class="ship-sheet-ov"
       @click.self="close">
    <div ref="sheet"
         class="ship-sheet"
         role="dialog"
         aria-modal="true"
         aria-labelledby="ship-howto-title"
         tabindex="-1">
      <button type="button"
              class="btn btn-default ship-sheet-x"
              :aria-label="$t('messenger.ship.sheet.close')"
              @click="close">
        <i class="fal fa-times"></i>
      </button>

      <div class="ship-sheet-body">
        <h5 id="ship-howto-title"
            class="header-text text-color-4 mb-3">{{ $t("messenger.ship.howto.title") }}</h5>
        <ul class="ship-why-list">
          <li>{{ $t("messenger.ship.howto.line_1") }}</li>
          <li>{{ $t("messenger.ship.howto.line_2") }}</li>
          <li>{{ $t("messenger.ship.howto.line_3") }}</li>
        </ul>
        <button type="button"
                class="btn btn-primary mt-3 w-100"
                @click="close">{{ $t("messenger.ship.howto.got_it") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
// ดูวิธีใช้: the 3-line เปิดบิลในแชท explainer
export default {
  name: "ShipHowToSheet",
  mounted() {
    document.body.classList.add("--sheet-open");
    document.addEventListener("keydown", this.onKey);
    this.$nextTick(() => {
      if (this.$refs.sheet) this.$refs.sheet.focus();
    });
  },
  beforeDestroy() {
    document.body.classList.remove("--sheet-open");
    document.removeEventListener("keydown", this.onKey);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onKey(event) {
      if (event && event.key === "Escape") this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.ship-sheet .btn {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ship-sheet-ov {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

@media (min-width: 768px) {
  .ship-sheet-ov {
    align-items: center;
    padding: 2rem;
  }
}

.ship-sheet {
  position: relative;
  width: 100%;
  max-width: 720px;
  max-height: 88vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 16px 16px 0 0;
}

@media (min-width: 768px) {
  .ship-sheet {
    border-radius: 16px;
  }
}

.ship-sheet-x {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 2;
  min-width: 44px;
}

.ship-sheet-body {
  padding: 3.5rem 1.25rem 1.25rem;
}

.ship-why-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  color: #444;
  font-size: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    gap: 0.6rem;

    &::before {
      content: "•";
      color: $brand-blue-mid;
      flex: 0 0 auto;
    }
  }
}

body.--dark {
  .ship-sheet {
    background: #373737;
  }

  .ship-why-list {
    color: lightgray;
  }
}
</style>
